import { useEffect, useState } from "react";

import useData from "../../hooks/useData";
import useLocalization from "../../hooks/useLocalization";

import { Box, Stack, Typography } from "@mui/material";

import InfoBox from "../layout/InfoBox";

const Controls = ({ surveyQuestionId }) => {
  const { executeAction } = useData();
  const { getLabel } = useLocalization();

  const [controls, setControls] = useState(null);

  useEffect(() => {
    getData();
  }, [surveyQuestionId]);

  const getData = async () => {
    setControls(null);

    if (!surveyQuestionId) return;

    const results = await executeAction({
      entityName: "SurveyQuestion",
      action: "controls",
      data: { surveyQuestionId },
    });

    const data = results?.isSuccessful ? results.data : null;

    if (data && data.pages && data.sections && data.questions) {
      if (
        data.pages.length > 0 ||
        data.sections.length > 0 ||
        data.questions.length > 0
      ) {
        setControls(data);
      }
    }
  };

  if (!controls) return null;

  return (
    <InfoBox label={getLabel("controls")}>
      <Box
        display="flex"
        flexDirection="column"
        gap={1}
      >
        {controls.pages.length > 0 ? (
          <Stack>
            <Typography sx={{ fontSize: "12px", fontWeight: "bold" }}>
              {getLabel("pagesControlled")}
            </Typography>
            {controls.pages.map((page) => (
              <Typography sx={{ fontSize: "10px" }}>{page.name}</Typography>
            ))}
          </Stack>
        ) : null}

        {controls.sections.length > 0 ? (
          <Stack>
            <Typography sx={{ fontSize: "12px", fontWeight: "bold" }}>
              {getLabel("sectionsControlled")}
            </Typography>
            {controls.sections.map((section) => (
              <Typography sx={{ fontSize: "10px" }}>{section.name}</Typography>
            ))}
          </Stack>
        ) : null}

        {controls.questions.length > 0 ? (
          <Stack>
            <Typography sx={{ fontSize: "12px", fontWeight: "bold" }}>
              {getLabel("questionsControlled")}
            </Typography>
            {controls.questions.map((question) => (
              <Typography sx={{ fontSize: "10px" }}>{question.name}</Typography>
            ))}
          </Stack>
        ) : null}
      </Box>
    </InfoBox>
  );
};

export default Controls;
